import styled from '@emotion/styled';
import { Dialog, DialogTitle } from '@mui/material';
import { black } from 'Styles/colors';
import { breakpoints } from 'Styles/theme';

export const StyledDialog = styled(Dialog)`
  .MuiPaper-root {
    max-width: 550px;
  }
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr fit-content(75%) 1fr;
  background-color: #3399ff;
`;

export const StyledDialogTitle = styled(DialogTitle)(
  ({ theme }) => `
    align-self: center;
    font-weight: bold;
    font-size: 24px;
    color: white;

    ${theme.breakpoints.down(breakpoints.TABLET)} {
      font-size: 18px;
      padding: 0 0 0 14px;
    }
    `,
);

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  color: white;
`;

export const ContentContainer = styled.div(
  ({ theme }) => `
    height: 100%;
    margin: 0 auto;
    padding: 16px 16px 32px;

    display: flex;
    flex-direction: column;
    color: ${black._87};

    align-items: center;

    ${theme.breakpoints.up(breakpoints.MOBILE)} {
        width: 65%;
    }
    ${theme.breakpoints.up(breakpoints.DESKTOP)} {
        width: 48%;
    }
    ${theme.breakpoints.down(breakpoints.TABLET)} {
        width: 90%;
    }
    `,
);

export const ContentText = styled.div(
  ({ theme }) => `
  font-size: 16px;
  text-align: center;
  padding-top: 12px;
  margin: auto;
  margin-bottom: 20px;

  ${theme.breakpoints.up(breakpoints.MOBILE)} {
    width: 90%;
  }
  ${theme.breakpoints.down(breakpoints.MOBILE)} {
    width: 70%;
  }
`,
);
